import * as React from "react";

export function useMapInteractionGate(
  mapRef: React.MutableRefObject<google.maps.Map | null>,
  mapLoaded: boolean,
  delayMs = 150
) {
  const [settled, setSettled] = React.useState(true);
  const tRef = React.useRef<number | null>(null);

  React.useEffect(() => {
    if (!mapLoaded || !mapRef.current) return;
    const map = mapRef.current;

    const markBusy = () => {
      setSettled(false);
      if (tRef.current) window.clearTimeout(tRef.current);
      tRef.current = null;
    };

    const markSettledSoon = () => {
      if (tRef.current) window.clearTimeout(tRef.current);
      tRef.current = window.setTimeout(() => {
        tRef.current = null;
        setSettled(true);
      }, delayMs);
    };

    const l1 = map.addListener("zoom_changed", markBusy);
    const l2 = map.addListener("dragstart", markBusy);
    const l2b = map.addListener("drag", markBusy);
    const l3 = map.addListener("idle", markSettledSoon);

    markSettledSoon();

    return () => {
      google.maps.event.removeListener(l1);
      google.maps.event.removeListener(l2);
      google.maps.event.removeListener(l2b);
      google.maps.event.removeListener(l3);
      if (tRef.current) window.clearTimeout(tRef.current);
      tRef.current = null;
    };
  }, [mapLoaded, mapRef, delayMs]);

  return settled;
}
